import { TM_URL } from '@/constants/constants'

export const termsOfService = 'https://www.textmagic.com/terms-of-service/'
export const privacyPolicy = 'https://www.textmagic.com/privacy-policy/'
export const textMagicLink = 'https://www.textmagic.com/'
export const textMagicSupport = 'https://support.textmagic.com/contact-us/'
export const openAIPrivacyPolicy = 'https://openai.com/enterprise-privacy/'
export const whatsAppBusinessAccount = 'https://business.facebook.com/wa/manage/home/'
export const superAdminLink = `${TM_URL}/admin`
export const supportEmail = 'support@textmagic.com'

export const usersWorkflowLink = 'https://support.textmagic.com/article/add-users-and-share-access-for-better-teamwork/'

export const tollFreeNumberMessagingLink = 'https://support.textmagic.com/article/toll-free-number-messaging/'

export const tenDlcMessagingLink = 'https://support.textmagic.com/article/10dlc-messaging/'
export const tenDlcBrandRegistrationLink =
  'https://support.textmagic.com/article/10dlc-registration-guide/#brand-registration'

export const whatsAppBusinessUrl = 'https://business.whatsapp.com/'

export const whatsAppSupportArticleLink = 'https://support.textmagic.com/article/whatsapp-integration/'

export const whatsAppBusinessPricingUrl = 'https://business.whatsapp.com/products/platform-pricing'

export const facebookSupportArticleLink = 'https://support.textmagic.com/article/facebook-integration/'

export const instagramSupportArticleLink = 'https://support.textmagic.com/article/instagram-integration/'

export const textTransliterationTool = 'https://freetools.textmagic.com/text-transliteration-tool'

export const faqMaximumLengthOfTextMessage = 'https://support.textmagic.com/faq/maximum-length-of-a-text-message/'

export const faqSmsCharges = 'https://support.textmagic.com/faq/how-am-i-charged-when-i-send-text-messages/'

export const webWidgetSupportArticleLink = 'https://support.textmagic.com/article/web-widget'

export const tenDlcCasesArticleLink = ' https://support.textmagic.com/article/10dlc-registration-guide/#cases'

export const businessTextMessagingLink = 'https://www.textmagic.com/business-text-messaging/'

export const byocLink = 'https://www.textmagic.com/bring-your-own-cpaas/'

export const stripeLink = 'https://stripe.com/'

export const notificationsTasks = 'https://app.textmagic.com/settings/account/notifications'

export const howAmChargedWhenISendTextMessagesLink =
  'https://support.textmagic.com/faq/how-am-i-charged-when-i-send-text-messages/'

export const deliverabilityChecklist = 'https://www.textmagic.com/blog/email-deliverability-checklist/'
export const emailDeliverabilityChecklistLink = 'https://www.textmagic.com/blog/email-deliverability-checklist/'
export const compliantExampleLink = 'https://app.textmagic.com/widget/subscribe/02c35c5f3f9d0f9'

export const smsPricingLink = 'https://www.textmagic.com/sms-pricing/'
export const smsPricingTableLink = 'https://www.textmagic.com/sms-pricing/#pricingTable'

export const getStartedWithHelpdeskEmailTicketsLink =
  'https://support.textmagic.com/article/get-started-with-helpdesk-email-tickets/'

export const touchpointAppLink =
  'https://touchpoint.textmagic.com?utm_source=textmagic_webapp&utm_medium=webapp&utm_campaign=touchpoint_launch'

export const zapierIntegrations = 'https://zapier.com/apps/textmagic/integrations'

export const sendingTextMessagesInUsaCanadaLink =
  'https://support.textmagic.com/article/sending-text-messages-in-the-usa-canada/'
export const useCpaasProviderLink = 'https://support.textmagic.com/article/use-your-cpaas-provider-with-textmagic-app/'
export const tenDlcRegistrationGuideLink = 'https://support.textmagic.com/article/10dlc-registration-guide/'
export const acceptableSmsConsentMethodsLink =
  'https://support.textmagic.com/article/acceptable-consent-methods-for-sms-messaging/'

export const connectYourEmailDomainLink = 'https://support.textmagic.com/article/connect-your-email-domain/'
export const gettingStartedWithEmailCampaignsLink =
  'https://support.textmagic.com/video/getting-started-with-email-campaigns/'
export const bestPracticesForSendingEmailCampaignsLink =
  'https://support.textmagic.com/article/best-practices-for-sending-email-campaigns/'
export const strongDomainReputationLink =
  'https://support.textmagic.com/article/ensure-email-delivery-with-a-strong-domain-reputation/'

export const textMagicFeaturesLink = 'https://www.textmagic.com/features/'
export const chatWidgetSupportArticleLink = 'https://support.textmagic.com/article/chat-widget/'
export const sharedInboxEmailsTicketsLink =
  'https://support.textmagic.com/article/set-up-your-shared-inbox-emails-tickets/'

export const automationWebhookLimitsLink = 'https://support.textmagic.com/article/send-webhook-guide/#limits'
export const automationWebhookAuthOptionsLink = 'https://support.textmagic.com/article/send-webhook-guide/#auth'

export const hubspotIntegrationGuide = 'https://support.textmagic.com/article/textmagic-hubspot-integration-guide/'
